'use client';

import { Box, Flex, Skeleton, Stack } from '@chakra-ui/react';
import { SkeletonText } from '@/components/ui/skeleton';

/**
 * Inline placeholders for product title / description / price.
 * Keeps page chrome and image area; not a full-screen loader.
 */
export default function ProductDetailsSkeleton() {
  return (
    <Stack mt={6} pb={{ base: 24, lg: 20 }} flex={1} gap={0}>
      <Box px={4}>
        <Skeleton
          h={{ base: '28px', lg: '36px' }}
          w={{ base: '75%', lg: '65%' }}
          rounded={8}
        />
        <Skeleton mt={2} h='16px' w='100px' rounded={6} />
        <Stack mt={4} gap={2}>
          <SkeletonText noOfLines={3} gap='2' />
        </Stack>
      </Box>

      <Box flex={1} px={4} mt={6}>
        <Skeleton h='40px' w='160px' rounded={12} />
        <Skeleton mt={3} h='40px' w='120px' rounded={12} />
      </Box>

      <Flex
        px={4}
        py={3}
        gap={3}
        align='center'
        justify='space-between'
        borderTop='1px solid'
        borderColor='#00000014'
        bg='background.card'
        position={{ base: 'fixed', lg: 'absolute' }}
        bottom={0}
        left={0}
        right={0}
      >
        <Skeleton h='28px' w='110px' rounded={8} />
        <Skeleton h='48px' flex={1} maxW='240px' rounded={16} />
      </Flex>
    </Stack>
  );
}
